import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import shoorahLogo from '../../../assets/images/shoorah-logo.jpg';
import { on } from 'ws';

const ChallengesCard = ({
  title,
  onViewAllTap,
  dataList,
  onDropDownSelect,
  preview = false,
  view = true
}) => {
  const navigate = useNavigate();
  console.log(dataList, 'dataListdataList2222222222222');

  // useEffect(() => {
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);
  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setIsShowDropdown(false);
  //   }
  // };

  return (
    <div className="bg-white border-[1.5px] border-shoorah-borderGray rounded-[16px] mt-5 mb-[18px] px-5 md:px-6 pt-6 pb-8 dark:bg-shoorah-darkBgTabColor dark:border-none">
      <div className="horizontal-card-header grid grid-cols-12 mb-[27px] items-center">
        <div className="sm:col-span-7 col-span-9">
          <p className="sm:text-2xl text-[14px] leading-9 font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {title}
          </p>
        </div>
        {view && (
          <div className="sm:col-span-5 col-span-3">
            <button
              className="sm:text-[14px] text-[12px] text-shoorah-active ms-auto w-full text-right text-nowrap"
              onClick={() => {
                onViewAllTap();
              }}
            >
              View All
            </button>
          </div>
        )}
      </div>

      <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
        {dataList?.length === 0 ? (
          <div className="flex justify-center items-center h-full w-full">
            <p className="text-[20px] text-shoorah-customGray">No data available</p>
          </div>
        ) : (
          (dataList && (view ? dataList?.slice(0, preview ? 6 : 3) : dataList))?.map(
            (data, index) => (
              // dataList?.slice(0, preview ? 6 : 3)?.map((data, index) => (
              <div
                key={index}
                onClick={() => {
                  navigate('/challenges/create-new-challenges?page=details', {
                    state: { _id: data?._id }
                  });
                }}
                className="cursor-pointer card-content grid grid-cols-12 border-[1.5px] border-shoorah-borderGray rounded-2xl p-[14px] w-full   gap-[16px]  flex-shrink-0 dark:bg-shoorah-darkBgColor dark:border-none"
              >
                <div className="content-box  col-span-7 h-full flex flex-col justify-between ">
                  <p className="font-medium leading-4 text-[#000000] whitespace-normal dark:text-shoorah-darkBg">
                    {data?.title?.slice(0, 25)}
                    {/* {data.title ?} */}
                    {/* {'Full-wellness Check Rundown'} */}
                    {/* {data?.offerTitle ? data?.offerTitle : '50% off on all online breathework sessions'} */}
                  </p>
                  <p className="text-xs text-[#000000] font-normal leading-4 dark:text-shoorah-darkBg">
                    {data?.description?.slice(0, 25)}
                    {/* {'With six simple actions set the tone for a restful...'} */}
                  </p>
                  {preview ? (
                    <Link
                      to={'/challenges/create-new-challenges?page=preview'}
                      state={{ _id: data?._id }}
                      onClick={(e) => e.stopPropagation()}
                      className="font-medium px-4 py-[6px] bg-[#F3F3F3] text-[#1A2230] rounded-full xl:text-[13px] text-[13px] max-w-[85px]"
                    >
                      Preview
                    </Link>
                  ) : (
                    <>
                      <p className="text-[12px] mb-[0px] text-[#18202F] font-normal leading-4 dark:text-shoorah-darkBg">
                        {'Expires in 3 days'}
                      </p>
                      <div className="h-[4px] w-full relative bg-[#E8E8E8] rounded-[4px]">
                        <div
                          className="absolute top-0 left-0 h-full bg-[#4954D6] rounded-[4px]"
                          style={{ width: `50%` }}
                        ></div>
                      </div>
                    </>
                  )}
                </div>
                <div className="img-box col-span-5 rounded-xl w-full h-full">
                  <img
                    src={data?.image ? data?.image : shoorahLogo}
                    // src={Array.isArray(data?.offerImages) && data.offerImages[0] ? data.offerImages[0] : shoorahLogo}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = shoorahLogo;
                    }}
                    alt="Template"
                    className="w-full h-full object-cover object-center rounded-xl min-h-[107px]"
                  />
                </div>
              </div>
            )
          )
        )}
      </div>
    </div>
  );
};

export default ChallengesCard;